import { createClient } from '@supabase/supabase-js';

// SECURITY 2026-05-21: anon key y SERVICE_ROLE key estaban hardcoded en
// este archivo como fallback string. Eso causó que ambos terminaran en
// el bundle JS público — incluyendo el service_role, que es admin total.
// Removidos. Ahora dependemos solo de las env vars:
//   REACT_APP_SUPABASE_URL
//   REACT_APP_SUPABASE_ANON_KEY
//   REACT_APP_SUPABASE_SERVICE_ROLE_KEY  ← SOLO debe existir en builds
//     donde el cliente NUNCA llegue al browser. Idealmente NO existe en
//     React. Operaciones admin deben pasar por un BFF.
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
const serviceRoleKey = process.env.REACT_APP_SUPABASE_SERVICE_ROLE_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    '[supabaseService] REACT_APP_SUPABASE_URL y ' +
    'REACT_APP_SUPABASE_ANON_KEY son requeridas en env vars. ' +
    'Configurar en Vercel + .env.local.'
  );
}

// Create base Supabase options with headers to fix 406 errors
const getSupabaseOptions = (key) => ({
  auth: {
    persistSession: true,
  },
  global: {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'apikey': key,
      'Authorization': `Bearer ${key}`,
      'Prefer': 'return=representation'
    },
  },
});

// Create a single supabase client for interacting with your database
export const supabase = createClient(supabaseUrl, supabaseAnonKey, getSupabaseOptions(supabaseAnonKey));

// Get an authenticated client for the current user
export const getAuthenticatedClient = () => {
  return supabase;
};

// Cached service client instance
let _serviceClient = null;

// Get a client with service role permissions for admin operations
export const getServiceClient = () => {
  if (!serviceRoleKey) {
    console.warn('Service role key not available, falling back to anon client');
    return supabase;
  }
  
  // Return cached instance if available
  if (_serviceClient) {
    return _serviceClient;
  }
  
  // Create and cache a new service client
  _serviceClient = createClient(supabaseUrl, serviceRoleKey, getSupabaseOptions(serviceRoleKey));
  return _serviceClient;
};

// Function to reinitialize the Supabase client (useful after authentication changes)
export const reinitializeSupabaseClient = () => {
  return createClient(supabaseUrl, supabaseAnonKey, getSupabaseOptions(supabaseAnonKey));
};

// Helper function to create a real-time subscription to a table
export const createTableSubscription = (table, events, callback) => {
  console.log(`Setting up real-time subscription for ${table}...`);
  
  try {
    const subscription = supabase
      .channel(`public:${table}`)
      .on('postgres_changes', { 
        event: events, 
        schema: 'public', 
        table 
      }, (payload) => {
        // Process the payload
        console.log('Received real-time update:', payload);
        callback(payload);
      })
      .subscribe();
    
    // Return cleanup function
    return () => {
      console.log(`Unsubscribing from ${table}...`);
      subscription.unsubscribe();
    };
  } catch (error) {
    console.error('Error setting up subscription:', error);
    return () => {}; // Empty cleanup function
  }
};

// Get storage bucket reference
export const getStorage = (bucket = 'documents') => {
  return supabase.storage.from(bucket);
};

// Export default supabase client
export default supabase; 